export const REQUEST_UPDATE_PASSWORD = 'REQUEST_UPDATE_PASSWORD';
export const REQUEST_UPDATE_PASSWORD_RECEIVED = 'REQUEST_UPDATE_PASSWORD_RECEIVED';